module.exports = __webpack_public_path__ + "img/borderWaves.eb7014a0.svg";